import { render, staticRenderFns } from "./PlaceFloatBtns.vue?vue&type=template&id=e8cf78b0&"
import script from "./PlaceFloatBtns.vue?vue&type=script&lang=js&"
export * from "./PlaceFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports